<div class="row justify-content-center mt-5 mb-5" *ngIf="!dataLoaded">
    <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
</div>
<div class="row" *ngIf="userProfile">
    <div class="col-sm-12">
        <p class="name text-center mt-5">{{ userProfile.firstName }} {{ userProfile.lastName }}</p>
        <div class="main-image-container row justify-content-center">
            <div class="profile-image-holder profile-picture flex-div mt-2 mb-2">
                <img *ngIf="selectedImage" [src]="selectedImage" alt="">
                <img *ngIf="!selectedImage" src="assets/account_placeholder.png" alt="">
                <div class="input-holder">
                    <input type="file" (change)="fileChangeEvent($event)">
                    <p>Change Photo</p>
                </div>
            </div>
        </div>
        <form [formGroup]="userProfileForm" class="profile-form col-lg-8 col-md-10 col-sm-12">
            <div class="input-holder row">
                <div class="header col-sm-12 col-lg-6">First Name: </div>
                <input class="form-control col-sm-12 col-lg-6" formControlName="firstName">
            </div>
            <div class="input-holder row">
                <div class="header col-sm-12 col-lg-6">Last Name: </div>
                <input class="form-control col-sm-12 col-lg-6" formControlName="lastName">
            </div>
            <div class="input-holder row">
                <div class="header col-sm-12 col-lg-6">Email: </div>
                <input type="email" class="form-control col-sm-12 col-lg-6" formControlName="email">
            </div>
            <div class="input-holder row">
                <div class="header col-sm-12 col-lg-6">Date of Birth: </div>
                <input type="date" class="form-control col-sm-12 col-lg-6" formControlName="dob">
            </div>
            <div class="input-holder row align-items-center">
                <div class="header col-6 col-sm-6 col-lg-6 mobile">Verified Mobile Number: </div>
                <div class="header col-6 col-sm-6 col-lg-6 mobile-res">
                    <p style="margin: 0; font-size: medium; padding-left: 4px;">{{ userProfile.phone }} <i class="ml-1 far fa-check-circle" style="color:#00a963;"></i></p>
                </div>
            </div>
            <p class="col-sm-12 text-right pr-0"><button [disabled]="userProfileForm.invalid" (click)="updateUser(userProfileForm.value)">Update</button></p>
        </form>
    </div>
</div>
